import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ProposalAICreatedCatalogBadge: React.FC = () => (
  <span className="proposal-ai-generator__created-badge">
    <FormattedMessage id="proposal-ai.catalog.created-badge" />
  </span>
);
